


// export default UserOverlay
import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setHoveredMarker } from "../../features/locs/locsSlice";
import avatar from "../../images/img/avatar.jpg";
import getPastDateAndTime from "../../helper/date/getPastDateAndTime";
import { setSelectUserData } from "../../features/user/userSlice";
import { showNestedModal } from "../../features/modal/modalSlice";

const Container = styled.div`
  position: absolute;
  top: ${({ topData }) => topData + "px"};
  left: ${({ leftData }) => leftData + "px"};
  transform: translate(-50%, -100%);
  background-color: #fff;
  color: #000;
  padding: 5px;
  border-radius: 8px;
  pointer-events: auto;
  z-index: 9999;
  border-bottom: 3px solid var(--color-main);
  display: flex;
  align-items: center;
  width: auto;
  height: auto;
  user-select: none;

  .left-side {
    padding: 10px;

    img{
      width: 100px;
      height: 100px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid var(--color-main);
    }

  }

  .right-side {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: auto;
    padding: 5px;
    padding-left: 15px;

    .username {
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
    }

    .phone-number {
      font-size: 12px;
      font-weight: var(--font-weight-lg);
    }

    .last-time{
      font-size: 12px;
      font-weight: var(--font-weight-lg);

    }

    .bottom-container{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 60px;

      .version{
        font-size: 12px;
        font-weight: var(--font-weight-lg);

      }

      .button{
        text-decoration: underline;
        color: var(--color-main);
        font-size: 12px;
        font-weight: var(--font-weight-lg);
      }
    }

  }
`;

const UserOverlay = ({ hoverTimeout }) => {
  const dispatch = useDispatch();
  const { hoveredMarker } = useSelector((state) => state.locs);

  const {isListView} = useSelector(state => state.boundaries)

  const handleOverlayMouseEnter = (e) => {
    if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
    e.stopPropagation();
  };

  const handleOverlayMouseLeave = (e) => {
    e.stopPropagation();
    dispatch(setHoveredMarker(null));
  };

  

  if (!hoveredMarker) return null;

  return (
    <Container
      topData={hoveredMarker.y - 10}
      leftData={isListView ? hoveredMarker.x - 190 : hoveredMarker.x}
      onMouseEnter={handleOverlayMouseEnter}
      onMouseLeave={handleOverlayMouseLeave}
    >
      <div className="left-side">
        <img
          src={
            hoveredMarker.profilePhoto
              ? `${process.env.REACT_APP_API_IMG_URI}${hoveredMarker.profilePhoto}`
              : avatar
          }
          alt=""
        />
      </div>
      <div className="right-side">
        <div className="username">{hoveredMarker?.adSoyadUnvan}</div>
        <div className="phone-number">{hoveredMarker?.phoneNumber}</div>
        <div className="last-time">Son Konum Alma: {getPastDateAndTime(hoveredMarker.konumSonGorulme).formattedDate} {getPastDateAndTime(hoveredMarker.konumSonGorulme).formattedTime}</div>
        <div className="bottom-container">
        <div className="version">Sürüm: {hoveredMarker.appVersionNumber}</div>
        <button className="button" onClick={() => {dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(hoveredMarker.phoneNumber))}}>Profili Görüntüle</button>

        </div>
      </div>
    </Container>
  );
};

export default UserOverlay;
